<div class="dependents">
  <ul>
    <li>
      <p class="codigo textoPagamento">Selecione a forma de pagamento</p>

      <div *ngIf="hasPaymentMethods">
        <div class="dependents">
          <div class="row-left">

            <div class="listItem">
              <div class="box-slide">
                <div class="money-box" [ngClass]="{'money-box-color-active': creditCard, 'money-box-color-deactive': !creditCard}">
                  <div class="button is-border box-home button-home padding-btn">Cartão</div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div *ngIf="creditCard || bankslip" class="recarga">
          <h2 class="valor-recarga">Valor do débito<br>
            <span class="valor-recarga">
              <app-input-currency [inputModel]="rechargeModel.amountInputModel" [(value)]="rechargeModel.amountToShow"></app-input-currency>
            </span>
          </h2>
        </div>

        <div *ngIf="creditCard">
          <div class="dadosCartao">
            <div class="list-menu">
              <ul>
                <li>
                  <div class="form-text">
                    <app-input-select [children]="paymentMethods" [placeholder]="'Selecione o cartão de crédito'"
                      [validators]="['required']" (isInputValid)="setFormStatus($event, 'paymentMethod')" [(value)]="paymentMethod"
                      class="mat-form-fieldmat-form-field-infix">Método de Pagamento</app-input-select>
                  </div>
                </li>
              </ul>
            </div>

            <div class="codigo">
              <h2 class="valor-recarga">Código de segurança<br>
                <span>
                  <app-input [inputModel]="rechargeModel.cvvInputModel" (isInputValid)="setFormStatus($event, 'cvv')"
                    [(value)]="rechargeModel.cvv"></app-input>
                </span>
              </h2>
            </div>
          </div>
        </div>

        <div class="descricao-dependentes">
          <button *ngIf="creditCard" (click)="pagar()" mat-raised-button class="confirma">
            Pagar
          </button>
        </div>
      </div>
      <div *ngIf="!hasPaymentMethods">

        <p class="registrarCartao">* Você ainda não tem uma forma de pagamento. Clique no botão e adicione um cartão de Crédito.</p>
          <button *ngIf="creditCard" (click)="goToCard(general/cartoes)" mat-raised-button class="confirma">
              Cadastrar cartão de crédito
            </button>
      </div>
    </li>
  </ul>
</div>


// WEBPACK FOOTER //
// /usr/src/app/src/app/components/debit-defaulters/debit-defaulters.component.html